import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types";
import { TextLink } from "../../TextLink";
import { BoldWrapper, ItalicWrapper, UnderlineWrapper } from "./ContentfulRichText.styles";
import { Heading2, Heading3, Heading4, Heading5, Heading6 } from "../../../Text";
var _obj, _obj1;
export var options = {
    renderMark: (_obj = {}, _define_property(_obj, MARKS.BOLD, function(text) {
        return /*#__PURE__*/ _jsx(BoldWrapper, {
            children: text
        });
    }), _define_property(_obj, MARKS.ITALIC, function(text) {
        return /*#__PURE__*/ _jsx(ItalicWrapper, {
            children: text
        });
    }), _define_property(_obj, MARKS.UNDERLINE, function(text) {
        return /*#__PURE__*/ _jsx(UnderlineWrapper, {
            children: text
        });
    }), _obj),
    renderNode: (_obj1 = {}, _define_property(_obj1, INLINES.HYPERLINK, function(param, children) {
        var data = param.data;
        return /*#__PURE__*/ _jsx(TextLink, {
            href: data.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "text",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_2, function(_, children) {
        return /*#__PURE__*/ _jsx(Heading2, {
            textColor: "current",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_3, function(_, children) {
        return /*#__PURE__*/ _jsx(Heading3, {
            textColor: "current",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_4, function(_, children) {
        return /*#__PURE__*/ _jsx(Heading4, {
            textColor: "current",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_5, function(_, children) {
        return /*#__PURE__*/ _jsx(Heading5, {
            textColor: "current",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_6, function(_, children) {
        return /*#__PURE__*/ _jsx(Heading6, {
            textColor: "current",
            children: children
        });
    }), _define_property(_obj1, BLOCKS.OL_LIST, function(_, children) {
        return /*#__PURE__*/ _jsx("ol", {
            children: children
        });
    }), _define_property(_obj1, BLOCKS.UL_LIST, function(_, children) {
        return /*#__PURE__*/ _jsx("ul", {
            children: children
        });
    }), _define_property(_obj1, BLOCKS.LIST_ITEM, function(_, children) {
        return /*#__PURE__*/ _jsx("li", {
            children: children
        });
    }), _define_property(_obj1, BLOCKS.TABLE, function(_, children) {
        return /*#__PURE__*/ _jsx("table", {
            children: /*#__PURE__*/ _jsx("tbody", {
                children: children
            })
        });
    }), _define_property(_obj1, BLOCKS.TABLE_ROW, function(_, children) {
        return /*#__PURE__*/ _jsx("tr", {
            children: children
        });
    }), _define_property(_obj1, BLOCKS.TABLE_CELL, function(_, children) {
        return /*#__PURE__*/ _jsx("td", {
            children: children
        });
    }), _define_property(_obj1, BLOCKS.TABLE_HEADER_CELL, function(_, children) {
        return /*#__PURE__*/ _jsx("th", {
            children: children
        });
    }), _obj1)
};
